import { useContext } from 'react';

import { AlertsContext } from '@/feature/alerts/components/AlertsProvider';

export const useAlerts = () => {
    const context = useContext(AlertsContext);
    if (context === undefined) {
        throw new Error('useAlerts must be used within an AlertsProvider');
    }
    return context;
};
